import { Link } from "react-router-dom"
import { Button, ReportButton } from "../../../components/Button"
import { MarkText } from "../../../components/MarkText"
import { OrgsIcon } from "../../../icons/OrgsIcon"
import { highlightText } from "../../../utils"

export const organisations = ({ pathname, showForm, isAdmin, context, org }) => {
    if (org === undefined) {
        return {
            enabled: isAdmin,
            header: isAdmin && <ReportButton makeReport={() => showForm("orgs_report")} />,
            footer: isAdmin && <Button onClick={() => showForm("organisations")}>
                        <OrgsIcon size={20} />
                        Add Organization
                    </Button>,
            columns: [
                {
                    title: "Name",
                    dataIndex: 'orgName',
                    defaultSortOrder: 'asc',
                    render: (text, record, index) => (
                        <Link to={`${pathname}/${record.key}`}>
                            <MarkText title={text} text={highlightText(text, context)} />
                        </Link>
                    ),
                    sorter: (a, b) => { if (a && a.hasOwnProperty("orgName") && a.orgName) return a.orgName.localeCompare(b.orgName) }
                },
                {
                    title: "Alias",
                    dataIndex: 'orgAlias',
                    width: 100,
                    render: (text, record, index) => (
                        <MarkText text={highlightText(text, context)} />
                    ),
                    sorter: (a, b) => { if (a && a.hasOwnProperty("orgAlias") && a.orgAlias) return a.orgAlias.localeCompare(b.orgAlias) }
                },
                {
                    title: "Phone",
                    dataIndex: "phone",
                    render: (text, record, index) => (
                        <MarkText text={highlightText(text, context)} />
                    ),
                    sorter: (a, b) => { if (a && a.hasOwnProperty("phone") && a.phone) return a.phone.localeCompare(b.phone) }
                },
                {
                    title: "Email",
                    dataIndex: "email",
                    render: (text, record, index) => (
                        <a href={`mailto: ${text}`}>
                            <MarkText text={highlightText(text, context)} />
                        </a>
                    ),
                    sorter: (a, b) => { if (a && a.hasOwnProperty("email") && a.email) return a.email.localeCompare(b.email) }
                }
            ]
        }
    }

    return null;
};